import * as React from 'react';
import {Tag} from './Tag';
import style from './tag.scss';

type UlElementProps = JSX.IntrinsicElements['ul'];

export interface TagInterface {
  tag: string;
  link?: string;
}

export interface TagsProps extends UlElementProps {
  tags: TagInterface[];
  newTab?: boolean;
  isPlaceholder?: boolean;
  wrapperComponent?: string | React.ComponentClass;
}

export function Tags({
  tags = [],
  wrapperComponent = 'ul',
  newTab,
  children,
  className,
  isPlaceholder,
  ...restProps
}: TagsProps) {
  const Wrapper = wrapperComponent;

  return (
    <Wrapper className={className} {...restProps}>
      {children}
      {tags.map((tag) => (
        <li key={tag.tag} className={style.listItem}>
          <Tag {...tag} newTab={newTab} isPlaceholder={isPlaceholder} />
        </li>
      ))}
    </Wrapper>
  );
}

export default Tags;
